module.exports = __webpack_public_path__ + "static/media/location-amman-jordan.778f3a25.jpg";